@if (paymentFormData(); as formData) {
  <h2 class="boels-checkout-title d-lg-block d-xl-block">
    {{ 'checkout.formPersonalDetails.heading' | transloco }}
  </h2>
  <form (ngSubmit)="submit(formData)" [formGroup]="formData.form()">
    <div class="row">
      <div [ngSwitch]="formData.registerdUser()" class="col-md-12">
        <ng-container *ngSwitchCase="true">
          <ng-container
            *ngTemplateOutlet="debtorForm; context: { $implicit: formData }"
          ></ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container
            *ngTemplateOutlet="
              billingAddressForm;
              context: { $implicit: formData }
            "
          ></ng-container>
        </ng-container>
        <p
          class="google-recaptcha-notice text-subtle-gray_1000"
          [innerHTML]="'form.googleRecaptcha.notice' | transloco"
        ></p>
      </div>
    </div>

    <hr class="divider" />
    <!-- Button section -->
    <div class="btn-container">
      <button
        boelsButton
        variant="primary-brand"
        type="submit"
        action="next"
        [alwaysShowActionIcon]="true"
      >
        {{ 'user.continue' | transloco }}
      </button>

      <button
        boelsButton
        variant="secondary"
        action="none"
        (click)="back()"
        [icon]="faChevronLeft"
      >
        {{ 'user.back' | transloco }}
      </button>
    </div>
  </form>
}

<!--Billing address form template-->

<ng-template
  #billingAddressForm
  [boelsTemplateContext]="paymentFormData()!"
  let-formData
>
  <ng-container [formGroup]="formData.form()">
    <!-- Customer Type -->
    <div class="boels-customer-type">
      <span
        >{{
          'checkout.formPersonalDetails.tradeEntities.type' | transloco
        }}?</span
      >
      <div class="form-check">
        <input
          #Individual
          class="boels-radio-button"
          type="radio"
          name="individualControl"
          (change)="onCustomerTypeChange(formData)"
          id="inlineRadio1"
          [value]="userType.INDIVIDUAL"
          formControlName="individualControl"
        />
        <label class="form-check-label" for="inlineRadio1">
          {{
            'checkout.formPersonalDetails.tradeEntities.individualCustomer'
              | transloco
          }}
        </label>
      </div>
      <div class="form-check">
        <input
          class="boels-radio-button"
          type="radio"
          name="individualControl"
          id="inlineRadio2"
          formControlName="individualControl"
          [value]="userType.BUSINESS"
          (change)="onCustomerTypeChange(formData)"
        />
        <label class="form-check-label" for="inlineRadio2">
          {{
            'checkout.formPersonalDetails.tradeEntities.tradeCustomer'
              | transloco
          }}
        </label>
      </div>
    </div>
    <hr class="divider" />

    <!-- Business User  -->
    @if (!Individual.checked) {
      <ng-container formGroupName="tradeCustomer">
        <h3 class="h3" style="padding-top: 0">
          {{
            'checkout.formPersonalDetails.tradeEntities.titleTop.label'
              | transloco
          }}
        </h3>

        <boels-text-input
          [required]="true"
          name="companyNameControl"
          [label]="
            'checkout.formPersonalDetails.tradeEntities.companyName' | transloco
          "
          type="text"
          formControlName="companyName"
          [formControl]="
            getControl(formData.form(), 'tradeCustomer', 'companyName')
          "
        ></boels-text-input>

        <boels-text-input
          name="debtorNumber"
          [label]="
            'checkout.formPersonalDetails.tradeEntities.debtorNumber'
              | transloco
          "
          type="text"
          formControlName="debtorNumber"
          [formControl]="
            getControl(formData.form(), 'tradeCustomer', 'debtorNumber')
          "
          [maxlength]="6"
          [faIcon]="faCircleInfo"
          [tooltipMessage]="
            'checkout.formPersonalDetails.tradeEntities.debtorNumberHint'
              | transloco
          "
          [additionalLabel]="
            'checkout.formPersonalDetails.tradeEntities.debtorNumberInfo'
              | transloco
          "
        ></boels-text-input>

        <boels-text-input
          name="vatNumber"
          [label]="
            'checkout.formPersonalDetails.tradeEntities.vatNumber' | transloco
          "
          type="text"
          formControlName="vatNumber"
          [formControl]="
            getControl(formData.form(), 'tradeCustomer', 'vatNumber')
          "
        ></boels-text-input>

        <boels-text-input
          name="chamberOfCommerceNumber"
          [label]="
            'checkout.formPersonalDetails.tradeEntities.chamberOfCommerceNumber'
              | transloco
          "
          type="text"
          formControlName="chamberOfCommerceNumber"
          [formControl]="
            getControl(
              formData.form(),
              'tradeCustomer',
              'chamberOfCommerceNumber'
            )
          "
        ></boels-text-input>
      </ng-container>
    }

    <!-- Billing -->
    <div class="boels-payment-form-billing">
      <h3 class="h3" style="padding-top: 0">
        {{ 'checkout.formPersonalDetails.titleTop.label' | transloco }}
      </h3>

      <boels-text-input
        [required]="true"
        name="email"
        [label]="'user.emailAddress.label' | transloco"
        type="email"
        [maxlength]="maxInputLengths.EMAIL_S1"
        formControlName="email"
        [formControl]="getControl(formData.form(), 'email')"
      ></boels-text-input>

      @if (formData.billingFormExternalSources?.titles$(); as titles) {
        @if (titles.titles && titles.titles.length !== 0) {
          <div class="select-container">
            <span class="label-content">
              {{ 'checkout.formBillingShipping.title.label' | transloco }}
            </span>
            <ng-select
              tabindex="0"
              [ngClass]="{
                isInvalid: getControl(formData.form(), 'titleCode').invalid,
              }"
              formControlName="titleCode"
              placeholder="
          {{ 'form.customerContactForm.placeholder' | transloco }}
          "
              [searchable]="false"
              [markFirst]="true"
              [clearable]="false"
              [items]="titles.titles || []"
              bindLabel="name"
              bindValue="code"
            >
            </ng-select>
            <boels-form-errors
              [control]="getControl(formData.form(), 'titleCode')"
            ></boels-form-errors>
          </div>
        }
      }

      <div class="row">
        <boels-text-input
          type="text"
          name="firstName"
          formControlName="firstName"
          [maxlength]="maxInputLengths.FIRST_NAME_S1"
          [required]="true"
          [label]="'checkout.formBillingShipping.firstName.label' | transloco"
          [formControl]="getControl(formData.form(), 'firstName')"
          class="col-sm-6"
        ></boels-text-input>

        <boels-text-input
          type="text"
          name="lastName"
          formControlName="lastName"
          [maxlength]="maxInputLengths.SURNAME_S1"
          [required]="true"
          [label]="'checkout.formBillingShipping.surname.label' | transloco"
          [formControl]="getControl(formData.form(), 'lastName')"
          class="col-sm-6"
        ></boels-text-input>
      </div>

      <!--Phone-->
      <ng-container
        *ngTemplateOutlet="phone; context: { $implicit: formData }"
      ></ng-container>
    </div>

    <!--Address-->
    <h3 class="h3">
      {{ 'checkout.formPersonalDetails.titleMiddle.label' | transloco }}
    </h3>
    <div class="row address-fields">
      <boels-text-input
        class="street-name col col-sm-12"
        [required]="true"
        name="line1"
        [label]="'checkout.formBillingShipping.address.streetName' | transloco"
        type="text"
        formControlName="line1"
        [maxlength]="maxInputLengths.STREET_S1"
        [formControl]="getControl(formData.form(), 'line1')"
      ></boels-text-input>
      <boels-text-input
        class="col col-sm-12 house-number"
        [required]="
          formData.billingFormMetaData?.isHouseNumberRequired() || false
        "
        name="line2"
        [label]="'checkout.formBillingShipping.address.houseNumber' | transloco"
        type="text"
        [maxlength]="maxInputLengths.HOUSE_NR_S1"
        formControlName="line2"
        [formControl]="getControl(formData.form(), 'line2')"
      ></boels-text-input>
    </div>

    <div class="row">
      <boels-text-input
        class="col col-md-6 col-sm-12"
        [required]="true"
        name="postalCode"
        [label]="'checkout.formBillingShipping.zipcode.label' | transloco"
        type="text"
        formControlName="postalCode"
        [maxlength]="maxInputLengths.ZIP_CODE_S1"
        [placeholder]="
          formData.billingFormMetaData?.postalCodePlaceholder() || ''
        "
        [customError]="
          formData.billingFormMetaData?.postalCodeValidationMessage() || ''
        "
        [formControl]="getControl(formData.form(), 'postalCode')"
      ></boels-text-input>

      <boels-text-input
        class="col col-md-6 col-sm-12"
        [required]="true"
        name="town"
        [label]="'checkout.formBillingShipping.city.label' | transloco"
        type="text"
        formControlName="town"
        [maxlength]="maxInputLengths.CITY_S1"
        [formControl]="getControl(formData.form(), 'town')"
      ></boels-text-input>
    </div>

    @if (formData.billingFormExternalSources?.countries$(); as countries) {
      <div
        class="select-container"
        *ngIf="countries.countries.length !== 0"
        formGroupName="country"
      >
        <span class="label-content">
          {{ 'checkout.formBillingShipping.country.label' | transloco }}
        </span>
        <ng-select
          tabindex="0"
          [ngClass]="{
            isInvalid: getControl(formData.form(), 'country', 'isocode')
              .invalid,
          }"
          [searchable]="true"
          [clearable]="false"
          [items]="countries.countries"
          bindLabel="name"
          bindValue="isocode"
          formControlName="isocode"
          (change)="
            getControl(formData.form(), 'country', 'isocode').setValue(
              $event.isocode
            )
          "
        >
        </ng-select>
        <boels-form-errors
          [control]="getControl(formData.form(), 'country', 'isocode')"
        ></boels-form-errors>
      </div>
    }
  </ng-container>
</ng-template>

<!--Debtor form template-->

<ng-template
  #debtorForm
  [boelsTemplateContext]="paymentFormData()!"
  let-formData
>
  <ng-container [formGroup]="formData.form()">
    <div class="boels-payment-form-billing">
      <div class="logout-container">
        <span class="label-user">
          {{
            'checkout.formBillingShipping.user.loggedInAs'
              | transloco: { value: getLoggedInAsDebtor(formData) }
          }}
        </span>
        <span class="label-logout">
          {{ 'checkout.formBillingShipping.user.notYou' | transloco }}
          <span class="logout-link" (click)="logoutDebtor()">
            {{ 'checkout.formBillingShipping.user.logout' | transloco }}
          </span>
        </span>
      </div>

      <div class="select-container">
        <span class="label-content">
          {{ 'checkout.formBillingShipping.debtor.label' | transloco }}
        </span>
        <boels-debtor-select
          [debtorForm]="formData.form()"
          [debtorFormControlName]="'debtor'"
          [debtorFormControl]="getControl(formData.form(), 'debtor')"
          [debtorAccounts]="formData.debtorFormMetaData?.debtorAccounts() || []"
          [invalidClass]="getControl(formData.form(), 'debtor').invalid"
          [isMobile]="$isMobile()"
        >
        </boels-debtor-select>
        <boels-form-errors
          [control]="getControl(formData.form(), 'debtor')"
        ></boels-form-errors>
      </div>

      <boels-text-input
        type="text"
        name="refenrece"
        formControlName="reference"
        [required]="true"
        [maxlength]="maxInputLengths.REFERENCE"
        [label]="'checkout.formBillingShipping.project.label' | transloco"
        [formControl]="getControl(formData.form(), 'reference')"
        class="col-sm-6"
      ></boels-text-input>

      <ng-container
        *ngTemplateOutlet="phone; context: { $implicit: formData }"
      ></ng-container>
    </div>
  </ng-container>
</ng-template>

<!--Phone template-->

<ng-template #phone [boelsTemplateContext]="paymentFormData()!" let-formData>
  <div class="phone-container">
    <span class="label-content">
      {{ 'checkout.formBillingShipping.tel.label' | transloco }}
    </span>
    <boels-phone
      [maxLength]="maxInputLengths.PHONE_NUMBER_S1"
      [phoneControl]="getControl(formData.form(), 'phone')"
    ></boels-phone>
    <boels-form-errors
      [control]="getControl(formData.form(), 'phone')"
      [hide]="
        !getControl(formData.form(), 'phone').touched &&
        (!getControl(formData.form(), 'phone').value ||
          getControl(formData.form(), 'phone').value?.number?.length === 0)
      "
    ></boels-form-errors>
  </div>
</ng-template>
